<app-nav-bar></app-nav-bar>

<div class="container-fluid" style="margin-top: 50px;">

	<div class="row">
		<div class="col-md-6">

			<img src="../../assets/images/join.gif" style="width: auto; height: 569px;float: right;">
		</div>
	<div class="col-md-6">

		<span style="
		font-size: 30px;
		font-weight: 600;
		color: #004526;
		font-family: 'Rubik', sans-serif;
		letter-spacing: .5px;
		padding: 0 68px;"
		>Join Meeting</span>
		<br>
		<br>
		<h2 style="
		font: 500 20px/32px Roboto, Helvetica Neue, sans-serif;
		 letter-spacing: .5px;
		 margin: 0 0 16px;
		 color: #736f6f;
		 padding: 0 74px;">Use Meeting ID and Password you received </h2>
				<h2 style="
				font: 500 20px/32px Roboto, Helvetica Neue, sans-serif;
				 letter-spacing: .5px;
				 margin: 0 0 16px;
				 color: #736f6f;
				 padding: 0 79px;">to  join meeting </h2>

<form name="form" (ngSubmit)="f.form.valid && joinMeeting()" #f="ngForm" novalidate>			 
<div class="row">
	<div class="col-md-7">
	 <div class="form-group">
	 <input type="text" name="ID" id="meetingID" class="form-control" 
	 placeholder="Meeting ID"
	 [(ngModel)]="model.ID" #ID="ngModel" [ngClass]="{ 'is-invalid': f.submitted && ID.invalid }" required>
	 <div *ngIf="f.submitted && ID.invalid" class="invalid-feedback">
		<!-- <div *ngIf="ID.errors.required" style="font-size: 15px;">*Meeting ID is required</div> -->
	</div>  


	 </div>
	</div>
	<div class="col-md-5">
	
	</div>
</div>

<div class="row">
 
 <div class="col-md-7">
  <div class="form-group">
  <input type="password" name="password" id="password" class="form-control"
  placeholder="Password"
  [(ngModel)]="model.password" #password="ngModel" [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" required>
  <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
	<!-- <div *ngIf="password.errors.required" style="font-size: 15px;">*Password is required</div> -->
</div>  
  </div>
 </div>
 <div class="col-md-5">
  
 </div>
</div>

<div class="row">
 
 <div class="col-md-12">
	 
		 <img src="../../assets/images/videop.png" style="margin-left: 172px;height: 49px;">
		 &nbsp;&nbsp;&nbsp;
	 <span style="font-size: 22px;font-weight: 500;">Enable Video</span>
	 &nbsp;&nbsp;&nbsp;
	 <label class="switch">
		 <input type="checkbox" checked>
		 <span class="slider round"></span>
	   </label>

 </div>

</div>
<div class="row">
 
 <div class="col-md-12">
	 
		 <img src="../../assets/images/audiop.png" style="margin-left: 180px;height: 49px;">
		 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
	 <span style="font-size: 22px;font-weight: 500;">Enable Audio</span>
	 &nbsp;&nbsp;&nbsp;&nbsp;
	 <label class="switch">
		 <input type="checkbox" checked>
		 <span class="slider round"></span>
	   </label>

 </div>
 
</div>
<div class="row">
 <div class="col-12">
	 <button type="submit" class="btn btn-warning btn-lg" 
	 style="
	 width: 350px;
	 margin-top: 35px;
	 font-size: 19px;
	 font-weight: 500;
	 line-height: 20px;
	 border: none;
	 margin-left: 145px;
	 height: 50px;
	 color: #fff;
	 background-color: #004526;"> 
	 Join Meeting</button>
</div>
</div>
</form>
</div>

</div>
	
<div class="loading-overlay">

	<span class="fa fa-spinner fa-spin" style="font-size:40px"></span>
</div>
</div>